import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) {
      setStatus("done");
      return;
    }
    const poll = async () => {
      if (attempts.current >= 8) {
        setStatus("done");
        return;
      }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch {}
      setTimeout(poll, 1800);
    };
    poll();
  }, []);

  return (
    <div className="mx-auto grid min-h-[60vh] max-w-lg place-items-center px-5 text-center">
      <div className="fade-up">
        {status === "checking" ? (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-primary-green" />
            <p className="mt-4 text-ppc-muted">{t("pay_processing")}</p>
          </>
        ) : (
          <>
            <span className="mx-auto grid h-16 w-16 place-items-center rounded-xl st-paid">
              <CheckCircle2 className="h-9 w-9 text-[#98dfc3]" />
            </span>
            <h1 className="font-display mt-6 text-3xl font-medium tracking-tight text-ppc-text">
              {t("pay_success_t")}
            </h1>
            <p className="mt-3 text-ppc-muted">{t("pay_success_d")}</p>
            <Button
              onClick={() => navigate("/dashboard")}
              data-testid="pay-success-dashboard-btn"
              className="mt-8 rounded-xl btn-primary px-6"
            >
              {t("back_dashboard")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
